import { useState, useEffect } from 'react'

export const useSearchPanel = (webviewName) => {
  const [searchPanelOpen, setSearchPanelOpen] = useState(false)
  const onSearchPanelClose = (event) => {
    event.stopPropagation()
    event.preventDefault()
    setSearchPanelOpen(false)
  }

  useEffect(() => {
    if (webviewName === 'lsApp') {
      window.__onNativeSearchClick = () => setSearchPanelOpen(!searchPanelOpen)
    }
    return () => {
      window.__onNativeSearchClick = null
    }
  }, [webviewName, searchPanelOpen])

  return {
    searchPanelOpen,
    setSearchPanelOpen,
    onSearchPanelClose,
  }
}
